import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { DOWNLOAD_PREDEFINED_TEMPLATE_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseDownloadPredefinedTemplateProps {
  templateId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const downloadPredefinedTemplate = async (templateId: string) =>
  await axiosAuth.get(`${DOWNLOAD_PREDEFINED_TEMPLATE_API}/${templateId}`, {
    responseType: "blob",
  });

const useDownloadPredefinedTemplate = ({templateId, queryParams}: UseDownloadPredefinedTemplateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["download-predefined-template", templateId],
    queryFn: () => downloadPredefinedTemplate(templateId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useDownloadPredefinedTemplate;
